import { Flex, Slider, Text } from '@byecode/ui'
import { EVENT_TYPE, EventConfig, ScrollEventProtocol } from '@lighthouse/core'
import { eventTypeName, ListItem4ByecodeUi, PopoverDropdownWithClose } from '@lighthouse/shared'
import React, { useCallback } from 'react'

import { CommonEventConfig } from './CommonEventConfig'

interface OtherEventConfigProps {
    value: ScrollEventProtocol
    onChange: (value: ScrollEventProtocol) => void
}

export const ScrollEventConfig: React.FC<OtherEventConfigProps> = ({ value, onChange }) => {
    const { type, config } = value
    const { bottom } = config
    const handleConfigChange = useCallback(
        (val: EventConfig) => {
            onChange({
                ...value,
                config: {
                    ...config,
                    ...val
                }
            })
        },
        [config, onChange, value]
    )

    const handleSliderChange = useCallback(
        (v: number) => {
            onChange({
                ...value,
                config: {
                    ...config,
                    bottom: v
                }
            })
        },
        [onChange, value, config]
    )

    return (
        <PopoverDropdownWithClose title={eventTypeName[EVENT_TYPE.SCROLL_BOTTOM].replace('x', `${bottom ?? 0}px`)}>
            <ListItem4ByecodeUi justifyContent="space-between" alignItems="center">
                <Flex>
                    <Text>触发阈值(px)</Text>
                </Flex>
                <Slider style={{ width: 180 }} min={0} max={500} defaultValue={bottom} onChange={handleSliderChange} />
            </ListItem4ByecodeUi>
            <CommonEventConfig value={config} onChange={handleConfigChange} />
        </PopoverDropdownWithClose>
    )
}
